import { render, staticRenderFns } from "./UpdateEmployeeWindow.vue?vue&type=template&id=28a6f0a8&"
import script from "./UpdateEmployeeWindow.vue?vue&type=script&lang=js&"
export * from "./UpdateEmployeeWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports